import React from 'react';
import PropTypes from 'prop-types';
import cx from 'src/classnames';
import { Tooltip } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { CONTACTS_NAMES, SNS_CONTACTS_NAMES } from '../../../constants/consts';
import { addProtocolIfNeed } from '../../../utils/common';
import VkIcon from '../../../public/images/icons/vkicon.svg';
import VimeoIcon from '../../../public/images/icons/vimeo.svg';
import cueTvIcon from '../../../public/images/icons/cueTvIcon.svg';
import ImageTag from '../../ImageTag';
import classes from './SocialIcons.module.scss';

const SocialIcon = ({ type, url, iconClass, colored }) => {
  const icon = React.useCallback(() => {
    if (type === SNS_CONTACTS_NAMES.FACEBOOK) {
      return <FacebookIcon className={classes.socialIcon} />;
    }
    if (type === SNS_CONTACTS_NAMES.TWITTER) {
      return <TwitterIcon className={classes.socialIcon} />;
    }
    if (type === SNS_CONTACTS_NAMES.INSTAGRAM) {
      return <InstagramIcon className={classes.socialIcon} />;
    }
    if (type === SNS_CONTACTS_NAMES.LINKEDIN) {
      return <LinkedInIcon className={classes.socialIcon} />;
    }
    if (type === SNS_CONTACTS_NAMES.YOUTUBE) {
      return <YouTubeIcon className={classes.socialIcon} />;
    }
    if (type === SNS_CONTACTS_NAMES.VK) {
      return <ImageTag src={VkIcon} className={classes.socialIcon} alt="VK Link" />;
    }
    if (type === SNS_CONTACTS_NAMES.VIMEO) {
      return <ImageTag src={VimeoIcon} className={classes.socialIcon} alt="vimeo" />;
    }
    if (type === SNS_CONTACTS_NAMES.CUETV) {
      return <ImageTag src={cueTvIcon} className={classes.socialIcon} alt="CueTv" />;
    }
  }, [type]);

  return (
    <a
      href={addProtocolIfNeed(url)}
      target="_blank"
      rel="noopener noreferrer"
      className={cx(classes.socialIconLink, { [classes[type]]: colored }, iconClass)}
      aria-label={type}
    >
      <Tooltip title={type}>{icon()}</Tooltip>
    </a>
  );
};

SocialIcon.propTypes = {
  type: PropTypes.oneOf([...Object.values(SNS_CONTACTS_NAMES), CONTACTS_NAMES.OTHER]),
  colored: PropTypes.bool,
  url: PropTypes.string,
};

SocialIcon.defaultProps = {
  colored: true,
};

export default SocialIcon;
